const Modal = require("react-modal");

exports.onClientEntry = () => {
  Modal.setAppElement("#___gatsby");
  if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
    document.body.classList.add("ios");
  }
};

const WhoPageModalUrlRegexp = RegExp('^/who/[^/]+/?$')
const WhoPageUrlRegexp = RegExp('^/who/?$')

exports.shouldUpdateScroll = (props) => {
  const { routerProps, prevRouterProps } = props
  const nextPathname = routerProps.location.pathname
  const prevPathname = prevRouterProps?.location?.pathname

  // do not scroll to top when opening or closing a modal
  const openedModal = WhoPageUrlRegexp.test(prevPathname) && WhoPageModalUrlRegexp.test(nextPathname)
  const closedModal = WhoPageModalUrlRegexp.test(prevPathname) && WhoPageUrlRegexp.test(nextPathname)
  const swipedModal = WhoPageModalUrlRegexp.test(prevPathname) && WhoPageModalUrlRegexp.test(nextPathname)
  return !(openedModal || closedModal || swipedModal)
}
